import axios from "axios";
import { useEffect, useState } from "react";
import { FaFile } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../api";
import { INewTemplate } from "../api/services/messaging.service";

export default function TemplateEditSection({
  template,
  forceRefresh,
}: {
  template: INewTemplate | null;
  forceRefresh: () => void;
}) {
  const [event, setEvent] = useState("");
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");

  useEffect(() => {
    if (template) {
      setEvent(template.event);
      setSubject(template.subject);
      setContent(template.content);
    }
  }, [template]);

  async function createTemplate() {
    try {
      let { status, data } = await api.messaging.addTemplate({
        content,
        event,
        subject,
        type: "EMAIL",
      });
      if (status === 200 && data.result) {
        toast.success("Template created");
        forceRefresh();
      } else {
        toast.error("Error on template creation");
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error("Something really went wrong!");
      }
    }
  }

  async function deleteTemplate(event?: string, type?: string) {
    try {
      if (event && type) {
        let { status, data } = await api.messaging.deleteTemplate(event, type);
        if (status === 204) {
          toast.success("Template deleted");
          forceRefresh();
        } else {
          toast.error("Error on template deletion");
        }
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error("Something really went wrong!");
      }
    }
  }

  return (
    <div className="flex flex-col rounded-2xl shadow-xl bg-white grow">
      <div className="flex items-center p-4 w-full border-b justify-between">
        <div className="flex items-center">
          <div className="flex items-center mr-10 rounded-lg">
            <div className="">
              <FaFile size={20} className="text-red-700" />
            </div>
            <span className="ml-2 font-medium leading-6 text-slate-700 text-lg flex break-all">
              {template && `Template: ${template.event}`}
              {!template && `No template selected`}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-col px-4 py-4 text-slate-700 content-between grow">
        <div className="flex flex-col space-y-4">
          <div>
            <label
              htmlFor="event"
              className="block text-sm font-medium text-gray-700"
            >
              Event
            </label>
            <div className="mt-1">
              <input
                id="event"
                name="event"
                type="text"
                autoComplete="event"
                required
                className="w-full px-3 py-2 border disabled:bg-slate-200 border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 focus:z-10 sm:text-sm"
                placeholder=""
                onChange={(targetEvent) => setEvent(targetEvent.target.value)}
                value={event}
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="subject"
              className="block text-sm font-medium text-gray-700"
            >
              Subject
            </label>
            <div className="mt-1">
              <input
                id="subject"
                name="subject"
                type="text"
                autoComplete="subject"
                required
                className="w-full px-3 py-2 border disabled:bg-slate-200 border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 focus:z-10 sm:text-sm"
                placeholder=""
                onChange={(targetSubject) =>
                  setSubject(targetSubject.target.value)
                }
                value={subject}
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="content"
              className="block text-sm font-medium text-gray-700"
            >
              Content
            </label>
            <div className="mt-1">
              <textarea
                id="content"
                name="content"
                required
                className="block p-2.5 w-full text-sm text-gray-900  rounded-l-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 group-hover h-80"
                placeholder=""
                onChange={(targetContent) =>
                  setContent(targetContent.target.value)
                }
                value={content}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col grow justify-end">
          <button
            type="submit"
            className="group relative w-full flex justify-center py-2 px-4 mt-5 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            onClick={() => createTemplate()}
          >
            Update Template
          </button>
          <button
            type="submit"
            className="group relative w-full flex justify-center py-2 px-4 mt-5 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            onClick={() => deleteTemplate(template?.event, template?.type)}
          >
            Delete Template
          </button>
        </div>
      </div>
    </div>
  );
}
